import React, { useContext } from "react";

import { PreferencesContext } from "@common/contexts/preferences";
import KeyboardInput from "@common/components/InputKeyboard";

const SportsbookCustomInput = ({ onClear, enableClearButton, ...props }) => {
  const [{ lang }] = useContext(PreferencesContext);


  return (
    <KeyboardInput
      {...props}
      disableSearchIcon
      lang={lang}
      enableClearButton={enableClearButton}
      clearSearchFiled={onClear}
    />
  );
};

export default SportsbookCustomInput;